//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { CommonServices } from "@/services/CommonServices";
import * as OM from "@/model";
import { baseUrl } from '@/config';

class _AppConfigClient {

  

  



  getCategories(showSpinner = true) : Promise<OM.CategoryConfigVm[]> {
  return CommonServices.defaultGet<OM.CategoryConfigVm[]>(baseUrl + 'api/AppConfig/GetCategories', {  }, showSpinner)
  }

  

  



  getConfig(showSpinner = true) : Promise<OM.AppConfig> {
  return CommonServices.defaultGet<OM.AppConfig>(baseUrl + 'api/AppConfig/GetConfig', {  }, showSpinner)
  }

  

  



    

    

    


  



  saveConfig(config : OM.AppConfig, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/AppConfig/SaveConfig', config, { }, showSpinner)
  }

  

  



    

    

    

      

    

    

    


  



  addCategory(name : string, file : File, progressFn: (prog) => void = null, showSpinner = true) : Promise<string> {
  return CommonServices.uploadFileToUrl<string>(baseUrl + 'api/AppConfig/AddCategory?name=' + name, file, { }, progressFn, showSpinner)
  }

  

  



    

    

    


  



  removeCategory(categoryName : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/AppConfig/RemoveCategory', { categoryName }, showSpinner)
  }
}
export let AppConfigClient = new _AppConfigClient();

class _ApprovationRequestClient {

  

  



  checkMyInvitation(showSpinner = true) : Promise<number> {
  return CommonServices.defaultGet<number>(baseUrl + 'api/ApprovationRequest/CheckMyInvitation', {  }, showSpinner)
  }

  

  



  getMyInvitationRequest(showSpinner = true) : Promise<OM.RequestVM[]> {
  return CommonServices.defaultGet<OM.RequestVM[]>(baseUrl + 'api/ApprovationRequest/GetMyInvitationRequest', {  }, showSpinner)
  }

  

  



    

    

    


  



  acceptInvitation(requestIdentifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/ApprovationRequest/AcceptInvitation', { requestIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  voidInvitation(requestIdentifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/ApprovationRequest/VoidInvitation', { requestIdentifier }, showSpinner)
  }
}
export let ApprovationRequestClient = new _ApprovationRequestClient();

class _AuthClient {

  

  



    

    

    


  



  login(model : OM.LanguageCredentialWithBirthDate, showSpinner = true) : Promise<OM.BaseApiLoginResponse> {
  return CommonServices.defaultPost<OM.BaseApiLoginResponse>(baseUrl + 'api/Auth/Login', model, { }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  



  redirectAccessToken(provider : string, access_token : string, showSpinner = true) : Promise<OM.BaseApiLoginResponse> {
  return CommonServices.defaultGet<OM.BaseApiLoginResponse>(baseUrl + 'api/Auth/RedirectAccessToken/oauth/redirectaccesstoken/{provider}', { provider, access_token }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  

    

    

    


  



  redirectAccessToken2(provider : string, access_token : string, displayName : string, showSpinner = true) : Promise<OM.BaseApiLoginResponse> {
  return CommonServices.defaultGet<OM.BaseApiLoginResponse>(baseUrl + 'api/Auth/RedirectAccessToken', { provider, access_token, displayName }, showSpinner)
  }

  

  



    

    

    


  



  changeCustomPassword(vm : OM.ChangeCustomPasswordVM, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/Auth/ChangeCustomPassword', vm, { }, showSpinner)
  }

  

  



    

    

    


  



  backendLogin(model : OM.LanguageCredentialWithBirthDate, showSpinner = true) : Promise<OM.LoginResponse> {
  return CommonServices.defaultPost<OM.LoginResponse>(baseUrl + 'api/Auth/BackendLogin', model, { }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  

    

    

    


  



  confirm(loginIdentifier : string, confirmationCode : string, preferredCulture : string, showSpinner = true) : Promise<OM.BaseApiLoginResponse> {
  return CommonServices.defaultGet<OM.BaseApiLoginResponse>(baseUrl + 'api/Auth/Confirm', { loginIdentifier, confirmationCode, preferredCulture }, showSpinner)
  }

  

  



  checkLogin(showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Auth/CheckLogin', {  }, showSpinner)
  }

  

  



  checkAndRefreshToken(showSpinner = true) : Promise<OM.LoginResponse> {
  return CommonServices.defaultPost<OM.LoginResponse>(baseUrl + 'api/Auth/CheckAndRefreshToken', null, { }, showSpinner)
  }

  

  



    

    

    


  



  register(model : OM.LanguageCredentialWithBirthDate, showSpinner = true) : Promise<OM.BaseApiLoginResponse> {
  return CommonServices.defaultPost<OM.BaseApiLoginResponse>(baseUrl + 'api/Auth/Register', model, { }, showSpinner)
  }

  

  



    

    

    


  



  completeProfile(vm : OM.RegisterVm, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/Auth/CompleteProfile', vm, { }, showSpinner)
  }

  

  



    

    

    


  



  changeLanguageAndGetToken(language : string, showSpinner = true) : Promise<string> {
  return CommonServices.defaultGet<string>(baseUrl + 'api/Auth/ChangeLanguageAndGetToken', { language }, showSpinner)
  }

  

  



    

    

    


  



  getAuthLink(provider : string, showSpinner = true) : Promise<string> {
  return CommonServices.defaultGet<string>(baseUrl + 'api/Auth/GetAuthLink/oauth/getauthlink/{provider}', { provider }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  



  redirectCode(provider : string, code : string, showSpinner = true) : Promise<OM.BaseApiLoginResponse> {
  return CommonServices.defaultGet<OM.BaseApiLoginResponse>(baseUrl + 'api/Auth/RedirectCode/oauth/redirectcode/{provider}', { provider, code }, showSpinner)
  }

  

  



    

    

    


  



  changePassword(newPassword : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Auth/ChangePassword', { newPassword }, showSpinner)
  }

  

  



    

    

    


  



  resetConfirmationCode(username : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Auth/ResetConfirmationCode', { username }, showSpinner)
  }

  

  



    

    

    


  



  resetPassword(username : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Auth/ResetPassword', { username }, showSpinner)
  }
}
export let AuthClient = new _AuthClient();

class _BaseChatClient {

  

  



    

    

    


  



  getConversationsAndRooms(userIdentifier : string, showSpinner = true) : Promise<OM.ChatListVm[]> {
  return CommonServices.defaultGet<OM.ChatListVm[]>(baseUrl + 'api/BaseChat/GetConversationsAndRooms', { userIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  getSingleChatListVm(identifier : string, showSpinner = true) : Promise<OM.ChatListVm> {
  return CommonServices.defaultGet<OM.ChatListVm>(baseUrl + 'api/BaseChat/GetSingleChatListVm', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  hasNewMessages(userIdentifier : string, showSpinner = true) : Promise<string[]> {
  return CommonServices.defaultGet<string[]>(baseUrl + 'api/BaseChat/HasNewMessages', { userIdentifier }, showSpinner)
  }
}
export let BaseChatClient = new _BaseChatClient();

class _BaseCommunityClient {

  

  



    

    

    


  



  getBySlug(slug : string, showSpinner = true) : Promise<OM.CommunityDetailVm> {
  return CommonServices.defaultGet<OM.CommunityDetailVm>(baseUrl + 'api/BaseCommunity/GetBySlug', { slug }, showSpinner)
  }

  

  



  reSaveAllWithSlug(showSpinner = true) : Promise<string> {
  return CommonServices.defaultGet<string>(baseUrl + 'api/BaseCommunity/ReSaveAllWithSlug', {  }, showSpinner)
  }

  

  



    

    

    


  



  getEnabledAndNotPublishedTags(communityIdentifier : string, showSpinner = true) : Promise<OM.SaveForumTagVM[]> {
  return CommonServices.defaultGet<OM.SaveForumTagVM[]>(baseUrl + 'api/BaseCommunity/GetEnabledAndNotPublishedTags', { communityIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  saveTag(tag : OM.SaveForumTagVM, showSpinner = true) : Promise<string> {
  return CommonServices.defaultPost<string>(baseUrl + 'api/BaseCommunity/SaveTag', tag, { }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  



  disableTag(tagIdentifier : string, communityIdentifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/BaseCommunity/DisableTag', { tagIdentifier, communityIdentifier }, showSpinner)
  }

  

  



  populateDiscoverPage(showSpinner = true) : Promise<OM.DiscoverCardVM[]> {
  return CommonServices.defaultGet<OM.DiscoverCardVM[]>(baseUrl + 'api/BaseCommunity/PopulateDiscoverPage', {  }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  



  getDiscoverCommunityInterested(skip : number, take : number, showSpinner = true) : Promise<OM.DiscoverCardVM[]> {
  return CommonServices.defaultGet<OM.DiscoverCardVM[]>(baseUrl + 'api/BaseCommunity/GetDiscoverCommunityInterested', { skip, take }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  



  getDiscoverCommunityNotInterested(skip : number, take : number, showSpinner = true) : Promise<OM.DiscoverCardVM[]> {
  return CommonServices.defaultGet<OM.DiscoverCardVM[]>(baseUrl + 'api/BaseCommunity/GetDiscoverCommunityNotInterested', { skip, take }, showSpinner)
  }

  

  



    

    

    


  



  getDiscoverCommunity(filter : OM.DiscoverFilterVM, showSpinner = true) : Promise<OM.DiscoverCardVM[]> {
  return CommonServices.defaultPost<OM.DiscoverCardVM[]>(baseUrl + 'api/BaseCommunity/GetDiscoverCommunity', filter, { }, showSpinner)
  }

  

  



    

    

    

      

    

    

    


  



  updateBackgroundImage(communityIdentifier : string, file : File, progressFn: (prog) => void = null, showSpinner = true) : Promise<string> {
  return CommonServices.uploadFileToUrl<string>(baseUrl + 'api/BaseCommunity/UpdateBackgroundImage?communityIdentifier=' + communityIdentifier, file, { }, progressFn, showSpinner)
  }

  

  



    

    

    

      

    

    

    


  



  updateLogoImage(communityIdentifier : string, file : File, progressFn: (prog) => void = null, showSpinner = true) : Promise<string> {
  return CommonServices.uploadFileToUrl<string>(baseUrl + 'api/BaseCommunity/UpdateLogoImage?communityIdentifier=' + communityIdentifier, file, { }, progressFn, showSpinner)
  }

  

  



    

    

    

      

    

    

    


  



  addGalleryImages(communityIdentifier : string, files : File[], progressFn: (prog) => void = null, showSpinner = true) : Promise<void> {
  return CommonServices.uploadFilesToUrl<void>(baseUrl + 'api/BaseCommunity/AddGalleryImages?communityIdentifier=' + communityIdentifier, files, { }, progressFn, showSpinner)
  }

  

  



    

    

    

      

    

    

    


  



  addGalleryImage(communityIdentifier : string, file : File, progressFn: (prog) => void = null, showSpinner = true) : Promise<string> {
  return CommonServices.uploadFileToUrl<string>(baseUrl + 'api/BaseCommunity/AddGalleryImage?communityIdentifier=' + communityIdentifier, file, { }, progressFn, showSpinner)
  }

  

  



    

    

    

      

    

    

    


  



  addSellingConditions(communityIdentifier : string, file : File, progressFn: (prog) => void = null, showSpinner = true) : Promise<void> {
  return CommonServices.uploadFileToUrl<void>(baseUrl + 'api/BaseCommunity/AddSellingConditions?communityIdentifier=' + communityIdentifier, file, { }, progressFn, showSpinner)
  }
}
export let BaseCommunityClient = new _BaseCommunityClient();

class _CartClient {

  

  



    

    

    


  



  addToCart(model : OM.AddToCartVm, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/Cart/AddToCart', model, { }, showSpinner)
  }

  

  



    

    

    


  



  getCartItemsCount(communityIdentifier : string, showSpinner = true) : Promise<number> {
  return CommonServices.defaultGet<number>(baseUrl + 'api/Cart/GetCartItemsCount', { communityIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  getCartDetail(communityIdentifier : string, showSpinner = true) : Promise<OM.CartVM> {
  return CommonServices.defaultGet<OM.CartVM>(baseUrl + 'api/Cart/GetCartDetail', { communityIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  changeAllItemsAmount(model : OM.ChangeCartAmountVm, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/Cart/ChangeAllItemsAmount', model, { }, showSpinner)
  }

  

  



    

    

    


  



  emptyCart(communityIdentifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Cart/EmptyCart', { communityIdentifier }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  



  setNotes(cartIdentifier : string, notes : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Cart/SetNotes', { cartIdentifier, notes }, showSpinner)
  }

  

  



    

    

    


  



  setShippingAddress(setAddressVM : OM.SetAddressVM, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/Cart/SetShippingAddress', setAddressVM, { }, showSpinner)
  }
}
export let CartClient = new _CartClient();

class _CategoryAttachmentClient {

  

  



    

    

    


  



  getCategoryAllAttachmentByCommunity(communityIdentifier : string, showSpinner = true) : Promise<OM.CategoryAttachmentVM[]> {
  return CommonServices.defaultGet<OM.CategoryAttachmentVM[]>(baseUrl + 'api/CategoryAttachment/GetCategoryAllAttachmentByCommunity', { communityIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  deleteCategoryAttachment(categoryId : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/CategoryAttachment/DeleteCategoryAttachment', { categoryId }, showSpinner)
  }

  

  



    

    

    


  



  addCategoryAttachment(category : OM.CategoryAttachmentVM, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/CategoryAttachment/AddCategoryAttachment', category, { }, showSpinner)
  }

  

  



    

    

    


  



  getCategoryById(categoryId : string, showSpinner = true) : Promise<OM.CategoryAttachmentVM> {
  return CommonServices.defaultGet<OM.CategoryAttachmentVM>(baseUrl + 'api/CategoryAttachment/GetCategoryById', { categoryId }, showSpinner)
  }
}
export let CategoryAttachmentClient = new _CategoryAttachmentClient();

class _ChatRoomClient {

  

  



    

    

    


  



  getById(identifier : string, showSpinner = true) : Promise<OM.ChatRoomVm> {
  return CommonServices.defaultGet<OM.ChatRoomVm>(baseUrl + 'api/ChatRoom/GetById', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  createChatRoom(vm : OM.CreateChatRoomVm, showSpinner = true) : Promise<string> {
  return CommonServices.defaultPost<string>(baseUrl + 'api/ChatRoom/CreateChatRoom', vm, { }, showSpinner)
  }

  

  



    

    

    

      

    

    

    


  



  updateChatroomImage(chatRoomId : string, file : File, progressFn: (prog) => void = null, showSpinner = true) : Promise<void> {
  return CommonServices.uploadFileToUrl<void>(baseUrl + 'api/ChatRoom/UpdateChatroomImage?chatRoomId=' + chatRoomId, file, { }, progressFn, showSpinner)
  }

  

  



    

    

    


  



  updateChatRoom(vm : OM.UpdateChatRoomVm, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/ChatRoom/UpdateChatRoom', vm, { }, showSpinner)
  }

  

  



    

    

    


  



  hasNewConversationMessages(userIdentifier : string, showSpinner = true) : Promise<string[]> {
  return CommonServices.defaultGet<string[]>(baseUrl + 'api/ChatRoom/HasNewConversationMessages', { userIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  getBaseChatRoomVm(identifier : string, showSpinner = true) : Promise<OM.BaseChatRoomVm> {
  return CommonServices.defaultGet<OM.BaseChatRoomVm>(baseUrl + 'api/ChatRoom/GetBaseChatRoomVm', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  getParticipants(chatRoomIdentifier : string, showSpinner = true) : Promise<OM.NameIdentifier[]> {
  return CommonServices.defaultGet<OM.NameIdentifier[]>(baseUrl + 'api/ChatRoom/GetParticipants', { chatRoomIdentifier }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  



  removeFromChat(userIdentifier : string, chatIdentifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/ChatRoom/RemoveFromChat', { userIdentifier, chatIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  removeAllPartecipants(chatRoomIdentifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/ChatRoom/RemoveAllPartecipants', { chatRoomIdentifier }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  

    

    

    


  



  getChatMessages(chatIdentifier : string, skip : number, take : number, showSpinner = true) : Promise<OM.ChatRoomMessageVM[]> {
  return CommonServices.defaultGet<OM.ChatRoomMessageVM[]>(baseUrl + 'api/ChatRoom/GetChatMessages', { chatIdentifier, skip, take }, showSpinner)
  }

  

  



    

    

    


  



  updateLastReadDate(chatIdentifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/ChatRoom/UpdateLastReadDate', { chatIdentifier }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  



  subscribe(chatRoomIdentifier : string, userIdentifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/ChatRoom/Subscribe', { chatRoomIdentifier, userIdentifier }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  



  unSubscribe(chatRoomIdentifier : string, userIdentifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/ChatRoom/UnSubscribe', { chatRoomIdentifier, userIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  uploadChatAttachment(file : File, progressFn: (prog) => void = null, showSpinner = true) : Promise<string> {
  return CommonServices.uploadFileToUrl<string>(baseUrl + 'api/ChatRoom/UploadChatAttachment', file, { }, progressFn, showSpinner)
  }

  

  



    

    

    


  



  getAdmins(chatRoomIdentifier : string, showSpinner = true) : Promise<string[]> {
  return CommonServices.defaultGet<string[]>(baseUrl + 'api/ChatRoom/GetAdmins', { chatRoomIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  setAdmins(vm : OM.SetListVmOfGuid, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/ChatRoom/SetAdmins', vm, { }, showSpinner)
  }

  

  



    

    

    


  



  getModerators(chatRoomIdentifier : string, showSpinner = true) : Promise<string[]> {
  return CommonServices.defaultGet<string[]>(baseUrl + 'api/ChatRoom/GetModerators', { chatRoomIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  setModerators(vm : OM.SetListVmOfGuid, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/ChatRoom/SetModerators', vm, { }, showSpinner)
  }

  

  



    

    

    


  



  getPermissions(communityIdentifier : string, showSpinner = true) : Promise<OM.PermissionSettings> {
  return CommonServices.defaultGet<OM.PermissionSettings>(baseUrl + 'api/ChatRoom/GetPermissions', { communityIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  setPermissions(vm : OM.SetValueVmOfPermissionSettings, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/ChatRoom/SetPermissions', vm, { }, showSpinner)
  }

  

  



    

    

    


  



  getChatRoomAllowances(chatRoomIdentifier : string, showSpinner = true) : Promise<OM.ChatRoomAllowanceVm> {
  return CommonServices.defaultGet<OM.ChatRoomAllowanceVm>(baseUrl + 'api/ChatRoom/GetChatRoomAllowances', { chatRoomIdentifier }, showSpinner)
  }
}
export let ChatRoomClient = new _ChatRoomClient();

class _CommentsClient {

  

  



    

    

    


  

    

    

    


  



  like(commentIdentifier : string, like : boolean, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Comments/Like', { commentIdentifier, like }, showSpinner)
  }

  

  



    

    

    


  



  getByParent(identifier : string, showSpinner = true) : Promise<OM.CommentVm[]> {
  return CommonServices.defaultGet<OM.CommentVm[]>(baseUrl + 'api/Comments/GetByParent', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  saveComment(vm : OM.AddCommentVm, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/Comments/SaveComment', vm, { }, showSpinner)
  }

  

  



    

    

    


  



  deleteComment(identifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Comments/DeleteComment', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  getSingleCommentVm(commentIdentifier : string, showSpinner = true) : Promise<OM.CommentVm> {
  return CommonServices.defaultGet<OM.CommentVm>(baseUrl + 'api/Comments/GetSingleCommentVm', { commentIdentifier }, showSpinner)
  }

  

  



  getAll(showSpinner = true) : Promise<OM.CommentListVM[]> {
  return CommonServices.defaultGet<OM.CommentListVM[]>(baseUrl + 'api/Comments/GetAll', {  }, showSpinner)
  }

  

  



    

    

    


  



  deleteCommentAdmin(commentIdentifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Comments/DeleteCommentAdmin', { commentIdentifier }, showSpinner)
  }
}
export let CommentsClient = new _CommentsClient();

class _CommunityClient {

  

  



  getByUser(showSpinner = true) : Promise<OM.CommunityListVm[]> {
  return CommonServices.defaultGet<OM.CommunityListVm[]>(baseUrl + 'api/Community/GetByUser', {  }, showSpinner)
  }

  

  



  getGestite(showSpinner = true) : Promise<OM.CommunityListVm[]> {
  return CommonServices.defaultGet<OM.CommunityListVm[]>(baseUrl + 'api/Community/GetGestite', {  }, showSpinner)
  }

  

  



    

    

    


  



  getBaseChatRoomVm(identifier : string, showSpinner = true) : Promise<OM.BaseChatRoomVm> {
  return CommonServices.defaultGet<OM.BaseChatRoomVm>(baseUrl + 'api/Community/GetBaseChatRoomVm', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  chatSearch(query : string, showSpinner = true) : Promise<OM.SearchResultVm[]> {
  return CommonServices.defaultGet<OM.SearchResultVm[]>(baseUrl + 'api/Community/ChatSearch', { query }, showSpinner)
  }

  

  



    

    

    


  



  like(communityIdentifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Community/Like', { communityIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  unLike(communityIdentifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Community/UnLike', { communityIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  subscribe(communityIdentifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Community/Subscribe', { communityIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  unSubscribe(communityIdentifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Community/UnSubscribe', { communityIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  getByCategory(category : string, showSpinner = true) : Promise<OM.CommunityListVm[]> {
  return CommonServices.defaultGet<OM.CommunityListVm[]>(baseUrl + 'api/Community/GetByCategory', { category }, showSpinner)
  }

  

  



  getByCategories(showSpinner = true) : Promise<OM.CommunityByCategoryVm[]> {
  return CommonServices.defaultGet<OM.CommunityByCategoryVm[]>(baseUrl + 'api/Community/GetByCategories', {  }, showSpinner)
  }

  

  



    

    

    


  



  getAdmins(communityIdentifier : string, showSpinner = true) : Promise<string[]> {
  return CommonServices.defaultGet<string[]>(baseUrl + 'api/Community/GetAdmins', { communityIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  getModerators(communityIdentifier : string, showSpinner = true) : Promise<string[]> {
  return CommonServices.defaultGet<string[]>(baseUrl + 'api/Community/GetModerators', { communityIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  setAdmins(vm : OM.SetListVmOfGuid, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/Community/SetAdmins', vm, { }, showSpinner)
  }

  

  



    

    

    


  



  setModerators(vm : OM.SetListVmOfGuid, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/Community/SetModerators', vm, { }, showSpinner)
  }

  

  



    

    

    


  



  getPermissions(communityIdentifier : string, showSpinner = true) : Promise<OM.PermissionSettings> {
  return CommonServices.defaultGet<OM.PermissionSettings>(baseUrl + 'api/Community/GetPermissions', { communityIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  setPermissions(vm : OM.SetValueVmOfPermissionSettings, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/Community/SetPermissions', vm, { }, showSpinner)
  }

  

  



    

    

    


  



  updateDescription(vm : OM.NameIdentifier, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/Community/UpdateDescription', vm, { }, showSpinner)
  }

  

  



    

    

    


  



  updateCommunityType(vm : OM.CommunityTypeVM, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/Community/UpdateCommunityType', vm, { }, showSpinner)
  }

  

  



    

    

    


  



  removeFromGallery(vm : OM.NameIdentifier, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/Community/RemoveFromGallery', vm, { }, showSpinner)
  }

  

  



    

    

    


  



  createCommunity(vm : OM.CreateCommunityVm, showSpinner = true) : Promise<OM.CreateCommunityResponseVM> {
  return CommonServices.defaultPost<OM.CreateCommunityResponseVM>(baseUrl + 'api/Community/CreateCommunity', vm, { }, showSpinner)
  }

  

  



    

    

    


  



  getById(identifier : string, showSpinner = true) : Promise<OM.CommunityDetailVm> {
  return CommonServices.defaultGet<OM.CommunityDetailVm>(baseUrl + 'api/Community/GetById', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  getUserCommunityLiked(userIdentifier : string, showSpinner = true) : Promise<OM.CommunityListVm> {
  return CommonServices.defaultGet<OM.CommunityListVm>(baseUrl + 'api/Community/GetUserCommunityLiked', { userIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  getUserCommunityManaged(userIdentifier : string, showSpinner = true) : Promise<OM.CommunityListVm> {
  return CommonServices.defaultGet<OM.CommunityListVm>(baseUrl + 'api/Community/GetUserCommunityManaged', { userIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  registerNewUserAccess(communityIdentifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Community/RegisterNewUserAccess', { communityIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  getAccessesByCommunity(communityIdentifier : string, showSpinner = true) : Promise<OM.CommunityAccessesVM> {
  return CommonServices.defaultGet<OM.CommunityAccessesVM>(baseUrl + 'api/Community/GetAccessesByCommunity', { communityIdentifier }, showSpinner)
  }

  

  



  getCertifiedsAsNameIdentifier(showSpinner = true) : Promise<OM.NameIdentifier[]> {
  return CommonServices.defaultGet<OM.NameIdentifier[]>(baseUrl + 'api/Community/GetCertifiedsAsNameIdentifier', {  }, showSpinner)
  }

  

  



    

    

    


  



  getUsersBlocked(communityIdentifier : string, showSpinner = true) : Promise<OM.NameIdentifier[]> {
  return CommonServices.defaultGet<OM.NameIdentifier[]>(baseUrl + 'api/Community/GetUsersBlocked', { communityIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  getAllegati(communityIdentifier : string, showSpinner = true) : Promise<OM.PostVm[]> {
  return CommonServices.defaultGet<OM.PostVm[]>(baseUrl + 'api/Community/GetAllegati', { communityIdentifier }, showSpinner)
  }

  

  



  getAll(showSpinner = true) : Promise<OM.CommunityListBackendVm[]> {
  return CommonServices.defaultGet<OM.CommunityListBackendVm[]>(baseUrl + 'api/Community/GetAll', {  }, showSpinner)
  }

  

  



    

    

    


  



  updateCommunity(vm : OM.CreateCommunityVm, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/Community/UpdateCommunity', vm, { }, showSpinner)
  }

  

  



    

    

    


  



  getGestiteBackend(userIdentifier : string, showSpinner = true) : Promise<OM.CommunityListBackendVm[]> {
  return CommonServices.defaultGet<OM.CommunityListBackendVm[]>(baseUrl + 'api/Community/GetGestiteBackend', { userIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  deleteById(identifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Community/DeleteById', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  disableById(identifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Community/DisableById', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  blockUser(item : OM.DeleteUserVM, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/Community/BlockUser', item, { }, showSpinner)
  }

  

  



    

    

    


  



  unblockUser(vm : OM.SetListVmOfGuid, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/Community/UnblockUser', vm, { }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  



  inviteUser(communityIdentifier : string, userIdentifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Community/InviteUser', { communityIdentifier, userIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  getBySlug(slug : string, showSpinner = true) : Promise<OM.CommunityDetailVm> {
  return CommonServices.defaultGet<OM.CommunityDetailVm>(baseUrl + 'api/Community/GetBySlug', { slug }, showSpinner)
  }

  

  



  reSaveAllWithSlug(showSpinner = true) : Promise<string> {
  return CommonServices.defaultGet<string>(baseUrl + 'api/Community/ReSaveAllWithSlug', {  }, showSpinner)
  }

  

  



    

    

    


  



  getEnabledAndNotPublishedTags(communityIdentifier : string, showSpinner = true) : Promise<OM.SaveForumTagVM[]> {
  return CommonServices.defaultGet<OM.SaveForumTagVM[]>(baseUrl + 'api/Community/GetEnabledAndNotPublishedTags', { communityIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  saveTag(tag : OM.SaveForumTagVM, showSpinner = true) : Promise<string> {
  return CommonServices.defaultPost<string>(baseUrl + 'api/Community/SaveTag', tag, { }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  



  disableTag(tagIdentifier : string, communityIdentifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Community/DisableTag', { tagIdentifier, communityIdentifier }, showSpinner)
  }

  

  



  populateDiscoverPage(showSpinner = true) : Promise<OM.DiscoverCardVM[]> {
  return CommonServices.defaultGet<OM.DiscoverCardVM[]>(baseUrl + 'api/Community/PopulateDiscoverPage', {  }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  



  getDiscoverCommunityInterested(skip : number, take : number, showSpinner = true) : Promise<OM.DiscoverCardVM[]> {
  return CommonServices.defaultGet<OM.DiscoverCardVM[]>(baseUrl + 'api/Community/GetDiscoverCommunityInterested', { skip, take }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  



  getDiscoverCommunityNotInterested(skip : number, take : number, showSpinner = true) : Promise<OM.DiscoverCardVM[]> {
  return CommonServices.defaultGet<OM.DiscoverCardVM[]>(baseUrl + 'api/Community/GetDiscoverCommunityNotInterested', { skip, take }, showSpinner)
  }

  

  



    

    

    


  



  getDiscoverCommunity(filter : OM.DiscoverFilterVM, showSpinner = true) : Promise<OM.DiscoverCardVM[]> {
  return CommonServices.defaultPost<OM.DiscoverCardVM[]>(baseUrl + 'api/Community/GetDiscoverCommunity', filter, { }, showSpinner)
  }

  

  



    

    

    

      

    

    

    


  



  updateBackgroundImage(communityIdentifier : string, file : File, progressFn: (prog) => void = null, showSpinner = true) : Promise<string> {
  return CommonServices.uploadFileToUrl<string>(baseUrl + 'api/Community/UpdateBackgroundImage?communityIdentifier=' + communityIdentifier, file, { }, progressFn, showSpinner)
  }

  

  



    

    

    

      

    

    

    


  



  updateLogoImage(communityIdentifier : string, file : File, progressFn: (prog) => void = null, showSpinner = true) : Promise<string> {
  return CommonServices.uploadFileToUrl<string>(baseUrl + 'api/Community/UpdateLogoImage?communityIdentifier=' + communityIdentifier, file, { }, progressFn, showSpinner)
  }

  

  



    

    

    

      

    

    

    


  



  addGalleryImages(communityIdentifier : string, files : File[], progressFn: (prog) => void = null, showSpinner = true) : Promise<void> {
  return CommonServices.uploadFilesToUrl<void>(baseUrl + 'api/Community/AddGalleryImages?communityIdentifier=' + communityIdentifier, files, { }, progressFn, showSpinner)
  }

  

  



    

    

    

      

    

    

    


  



  addGalleryImage(communityIdentifier : string, file : File, progressFn: (prog) => void = null, showSpinner = true) : Promise<string> {
  return CommonServices.uploadFileToUrl<string>(baseUrl + 'api/Community/AddGalleryImage?communityIdentifier=' + communityIdentifier, file, { }, progressFn, showSpinner)
  }

  

  



    

    

    

      

    

    

    


  



  addSellingConditions(communityIdentifier : string, file : File, progressFn: (prog) => void = null, showSpinner = true) : Promise<void> {
  return CommonServices.uploadFileToUrl<void>(baseUrl + 'api/Community/AddSellingConditions?communityIdentifier=' + communityIdentifier, file, { }, progressFn, showSpinner)
  }
}
export let CommunityClient = new _CommunityClient();

class _CommunityUserRequestClient {

  

  



    

    

    


  



  getAllRequest(communityIdentifier : string, showSpinner = true) : Promise<OM.RequestVM[]> {
  return CommonServices.defaultGet<OM.RequestVM[]>(baseUrl + 'api/CommunityUserRequest/GetAllRequest', { communityIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  acceptRequest(vm : OM.RequestVM, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/CommunityUserRequest/AcceptRequest', vm, { }, showSpinner)
  }

  

  



    

    

    


  



  voidRequest(vm : OM.RequestVM, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/CommunityUserRequest/VoidRequest', vm, { }, showSpinner)
  }
}
export let CommunityUserRequestClient = new _CommunityUserRequestClient();

class _ConversationRoomClient {

  

  



    

    

    


  



  getConversations(userIdentifier : string, showSpinner = true) : Promise<OM.ConversationRoomVm[]> {
  return CommonServices.defaultGet<OM.ConversationRoomVm[]>(baseUrl + 'api/ConversationRoom/GetConversations', { userIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  getById(identifier : string, showSpinner = true) : Promise<OM.ConversationRoomVm> {
  return CommonServices.defaultGet<OM.ConversationRoomVm>(baseUrl + 'api/ConversationRoom/GetById', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  checkConversationExisting(withUser : string, showSpinner = true) : Promise<string> {
  return CommonServices.defaultGet<string>(baseUrl + 'api/ConversationRoom/CheckConversationExisting', { withUser }, showSpinner)
  }

  

  



    

    

    


  



  getConversationRoomVm(identifier : string, showSpinner = true) : Promise<OM.ConversationRoomVm> {
  return CommonServices.defaultGet<OM.ConversationRoomVm>(baseUrl + 'api/ConversationRoom/GetConversationRoomVm', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  hasNewConversationMessages(userIdentifier : string, showSpinner = true) : Promise<string[]> {
  return CommonServices.defaultGet<string[]>(baseUrl + 'api/ConversationRoom/HasNewConversationMessages', { userIdentifier }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  

    

    

    


  



  getChatMessages(chatIdentifier : string, skip : number, take : number, showSpinner = true) : Promise<OM.ChatRoomMessageVM[]> {
  return CommonServices.defaultGet<OM.ChatRoomMessageVM[]>(baseUrl + 'api/ConversationRoom/GetChatMessages', { chatIdentifier, skip, take }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  



  subscribe(chatRoomIdentifier : string, userIdentifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/ConversationRoom/Subscribe', { chatRoomIdentifier, userIdentifier }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  



  unSubscribe(chatRoomIdentifier : string, userIdentifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/ConversationRoom/UnSubscribe', { chatRoomIdentifier, userIdentifier }, showSpinner)
  }

  

  



  uploadChatImage(showSpinner = true) : Promise<string> {
  return CommonServices.defaultPost<string>(baseUrl + 'api/ConversationRoom/UploadChatImage', null, { }, showSpinner)
  }
}
export let ConversationRoomClient = new _ConversationRoomClient();

class _DashboardClient {

  

  



  getDashboard(showSpinner = true) : Promise<OM.DashboardVm> {
  return CommonServices.defaultGet<OM.DashboardVm>(baseUrl + 'api/Dashboard/GetDashboard', {  }, showSpinner)
  }
}
export let DashboardClient = new _DashboardClient();

class _EventClient {

  

  



  getByCategories(showSpinner = true) : Promise<OM.EventByCategoryVm[]> {
  return CommonServices.defaultGet<OM.EventByCategoryVm[]>(baseUrl + 'api/Event/GetByCategories', {  }, showSpinner)
  }

  

  



    

    

    


  



  getById(identifier : string, showSpinner = true) : Promise<OM.EventDetailVm> {
  return CommonServices.defaultGet<OM.EventDetailVm>(baseUrl + 'api/Event/GetById', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  getByCategory(category : string, showSpinner = true) : Promise<OM.EventVm[]> {
  return CommonServices.defaultGet<OM.EventVm[]>(baseUrl + 'api/Event/GetByCategory', { category }, showSpinner)
  }

  

  



    

    

    


  



  getByCommunity(communityIdentifier : string, showSpinner = true) : Promise<OM.EventVm[]> {
  return CommonServices.defaultGet<OM.EventVm[]>(baseUrl + 'api/Event/GetByCommunity', { communityIdentifier }, showSpinner)
  }

  

  



  resaveAllEventsWithSlug(showSpinner = true) : Promise<string> {
  return CommonServices.defaultGet<string>(baseUrl + 'api/Event/ResaveAllEventsWithSlug', {  }, showSpinner)
  }

  

  



    

    

    


  



  editInfoEvent(vm : OM.EditEventInfo, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/Event/EditInfoEvent', vm, { }, showSpinner)
  }

  

  



    

    

    


  



  getEventAddress(identifier : string, showSpinner = true) : Promise<OM.Address> {
  return CommonServices.defaultGet<OM.Address>(baseUrl + 'api/Event/GetEventAddress', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  createEvent(vm : OM.CreateEventVm, showSpinner = true) : Promise<OM.CreateEventResponseVM> {
  return CommonServices.defaultPost<OM.CreateEventResponseVM>(baseUrl + 'api/Event/CreateEvent', vm, { }, showSpinner)
  }

  

  



    

    

    


  



  removeFromGallery(vm : OM.NameIdentifier, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/Event/RemoveFromGallery', vm, { }, showSpinner)
  }

  

  



  getAll(showSpinner = true) : Promise<OM.EventVm[]> {
  return CommonServices.defaultGet<OM.EventVm[]>(baseUrl + 'api/Event/GetAll', {  }, showSpinner)
  }

  

  



    

    

    


  



  deleteById(identifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Event/DeleteById', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  getByMonth(model : OM.CalendarFIlterVM, showSpinner = true) : Promise<OM.EventCalendarVM[]> {
  return CommonServices.defaultPost<OM.EventCalendarVM[]>(baseUrl + 'api/Event/GetByMonth', model, { }, showSpinner)
  }

  

  



    

    

    


  



  getByDay(filter : OM.CalendarFIlterVM, showSpinner = true) : Promise<OM.CommunityListVm[]> {
  return CommonServices.defaultPost<OM.CommunityListVm[]>(baseUrl + 'api/Event/GetByDay', filter, { }, showSpinner)
  }

  

  



    

    

    


  



  getByDayAsEventList(filter : OM.CalendarFIlterVM, showSpinner = true) : Promise<OM.EventVm[]> {
  return CommonServices.defaultPost<OM.EventVm[]>(baseUrl + 'api/Event/GetByDayAsEventList', filter, { }, showSpinner)
  }

  

  



    

    

    


  



  getBySlug(slug : string, showSpinner = true) : Promise<OM.CommunityDetailVm> {
  return CommonServices.defaultGet<OM.CommunityDetailVm>(baseUrl + 'api/Event/GetBySlug', { slug }, showSpinner)
  }

  

  



  reSaveAllWithSlug(showSpinner = true) : Promise<string> {
  return CommonServices.defaultGet<string>(baseUrl + 'api/Event/ReSaveAllWithSlug', {  }, showSpinner)
  }

  

  



    

    

    


  



  getEnabledAndNotPublishedTags(communityIdentifier : string, showSpinner = true) : Promise<OM.SaveForumTagVM[]> {
  return CommonServices.defaultGet<OM.SaveForumTagVM[]>(baseUrl + 'api/Event/GetEnabledAndNotPublishedTags', { communityIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  saveTag(tag : OM.SaveForumTagVM, showSpinner = true) : Promise<string> {
  return CommonServices.defaultPost<string>(baseUrl + 'api/Event/SaveTag', tag, { }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  



  disableTag(tagIdentifier : string, communityIdentifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Event/DisableTag', { tagIdentifier, communityIdentifier }, showSpinner)
  }

  

  



  populateDiscoverPage(showSpinner = true) : Promise<OM.DiscoverCardVM[]> {
  return CommonServices.defaultGet<OM.DiscoverCardVM[]>(baseUrl + 'api/Event/PopulateDiscoverPage', {  }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  



  getDiscoverCommunityInterested(skip : number, take : number, showSpinner = true) : Promise<OM.DiscoverCardVM[]> {
  return CommonServices.defaultGet<OM.DiscoverCardVM[]>(baseUrl + 'api/Event/GetDiscoverCommunityInterested', { skip, take }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  



  getDiscoverCommunityNotInterested(skip : number, take : number, showSpinner = true) : Promise<OM.DiscoverCardVM[]> {
  return CommonServices.defaultGet<OM.DiscoverCardVM[]>(baseUrl + 'api/Event/GetDiscoverCommunityNotInterested', { skip, take }, showSpinner)
  }

  

  



    

    

    


  



  getDiscoverCommunity(filter : OM.DiscoverFilterVM, showSpinner = true) : Promise<OM.DiscoverCardVM[]> {
  return CommonServices.defaultPost<OM.DiscoverCardVM[]>(baseUrl + 'api/Event/GetDiscoverCommunity', filter, { }, showSpinner)
  }

  

  



    

    

    

      

    

    

    


  



  updateBackgroundImage(communityIdentifier : string, file : File, progressFn: (prog) => void = null, showSpinner = true) : Promise<string> {
  return CommonServices.uploadFileToUrl<string>(baseUrl + 'api/Event/UpdateBackgroundImage?communityIdentifier=' + communityIdentifier, file, { }, progressFn, showSpinner)
  }

  

  



    

    

    

      

    

    

    


  



  updateLogoImage(communityIdentifier : string, file : File, progressFn: (prog) => void = null, showSpinner = true) : Promise<string> {
  return CommonServices.uploadFileToUrl<string>(baseUrl + 'api/Event/UpdateLogoImage?communityIdentifier=' + communityIdentifier, file, { }, progressFn, showSpinner)
  }

  

  



    

    

    

      

    

    

    


  



  addGalleryImages(communityIdentifier : string, files : File[], progressFn: (prog) => void = null, showSpinner = true) : Promise<void> {
  return CommonServices.uploadFilesToUrl<void>(baseUrl + 'api/Event/AddGalleryImages?communityIdentifier=' + communityIdentifier, files, { }, progressFn, showSpinner)
  }

  

  



    

    

    

      

    

    

    


  



  addGalleryImage(communityIdentifier : string, file : File, progressFn: (prog) => void = null, showSpinner = true) : Promise<string> {
  return CommonServices.uploadFileToUrl<string>(baseUrl + 'api/Event/AddGalleryImage?communityIdentifier=' + communityIdentifier, file, { }, progressFn, showSpinner)
  }

  

  



    

    

    

      

    

    

    


  



  addSellingConditions(communityIdentifier : string, file : File, progressFn: (prog) => void = null, showSpinner = true) : Promise<void> {
  return CommonServices.uploadFileToUrl<void>(baseUrl + 'api/Event/AddSellingConditions?communityIdentifier=' + communityIdentifier, file, { }, progressFn, showSpinner)
  }
}
export let EventClient = new _EventClient();

class _FieraClient {

  

  



  getAll(showSpinner = true) : Promise<OM.FieraListVm[]> {
  return CommonServices.defaultGet<OM.FieraListVm[]>(baseUrl + 'api/Fiera/GetAll', {  }, showSpinner)
  }

  

  



  getActives(showSpinner = true) : Promise<OM.FieraListVm[]> {
  return CommonServices.defaultGet<OM.FieraListVm[]>(baseUrl + 'api/Fiera/GetActives', {  }, showSpinner)
  }

  

  



    

    

    


  



  getCommunitiesOfFieraBySlug(slug : string, showSpinner = true) : Promise<OM.CategoryItemsOfNameSlugIdentifier[]> {
  return CommonServices.defaultGet<OM.CategoryItemsOfNameSlugIdentifier[]>(baseUrl + 'api/Fiera/GetCommunitiesOfFieraBySlug', { slug }, showSpinner)
  }

  

  



    

    

    


  



  getById(fieraIdentifier : string, showSpinner = true) : Promise<OM.FieraDetailVm> {
  return CommonServices.defaultGet<OM.FieraDetailVm>(baseUrl + 'api/Fiera/GetById', { fieraIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  deleteById(identifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Fiera/DeleteById', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  saveFiera(vm : OM.SaveFieraVm, showSpinner = true) : Promise<string> {
  return CommonServices.defaultPost<string>(baseUrl + 'api/Fiera/SaveFiera', vm, { }, showSpinner)
  }

  

  



  resaveAllFieraWithSlug(showSpinner = true) : Promise<string> {
  return CommonServices.defaultGet<string>(baseUrl + 'api/Fiera/ResaveAllFieraWithSlug', {  }, showSpinner)
  }

  

  



    

    

    


  



  getBySlug(slug : string, showSpinner = true) : Promise<OM.CommunityDetailVm> {
  return CommonServices.defaultGet<OM.CommunityDetailVm>(baseUrl + 'api/Fiera/GetBySlug', { slug }, showSpinner)
  }

  

  



  reSaveAllWithSlug(showSpinner = true) : Promise<string> {
  return CommonServices.defaultGet<string>(baseUrl + 'api/Fiera/ReSaveAllWithSlug', {  }, showSpinner)
  }

  

  



    

    

    


  



  getEnabledAndNotPublishedTags(communityIdentifier : string, showSpinner = true) : Promise<OM.SaveForumTagVM[]> {
  return CommonServices.defaultGet<OM.SaveForumTagVM[]>(baseUrl + 'api/Fiera/GetEnabledAndNotPublishedTags', { communityIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  saveTag(tag : OM.SaveForumTagVM, showSpinner = true) : Promise<string> {
  return CommonServices.defaultPost<string>(baseUrl + 'api/Fiera/SaveTag', tag, { }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  



  disableTag(tagIdentifier : string, communityIdentifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Fiera/DisableTag', { tagIdentifier, communityIdentifier }, showSpinner)
  }

  

  



  populateDiscoverPage(showSpinner = true) : Promise<OM.DiscoverCardVM[]> {
  return CommonServices.defaultGet<OM.DiscoverCardVM[]>(baseUrl + 'api/Fiera/PopulateDiscoverPage', {  }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  



  getDiscoverCommunityInterested(skip : number, take : number, showSpinner = true) : Promise<OM.DiscoverCardVM[]> {
  return CommonServices.defaultGet<OM.DiscoverCardVM[]>(baseUrl + 'api/Fiera/GetDiscoverCommunityInterested', { skip, take }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  



  getDiscoverCommunityNotInterested(skip : number, take : number, showSpinner = true) : Promise<OM.DiscoverCardVM[]> {
  return CommonServices.defaultGet<OM.DiscoverCardVM[]>(baseUrl + 'api/Fiera/GetDiscoverCommunityNotInterested', { skip, take }, showSpinner)
  }

  

  



    

    

    


  



  getDiscoverCommunity(filter : OM.DiscoverFilterVM, showSpinner = true) : Promise<OM.DiscoverCardVM[]> {
  return CommonServices.defaultPost<OM.DiscoverCardVM[]>(baseUrl + 'api/Fiera/GetDiscoverCommunity', filter, { }, showSpinner)
  }

  

  



    

    

    

      

    

    

    


  



  updateBackgroundImage(communityIdentifier : string, file : File, progressFn: (prog) => void = null, showSpinner = true) : Promise<string> {
  return CommonServices.uploadFileToUrl<string>(baseUrl + 'api/Fiera/UpdateBackgroundImage?communityIdentifier=' + communityIdentifier, file, { }, progressFn, showSpinner)
  }

  

  



    

    

    

      

    

    

    


  



  updateLogoImage(communityIdentifier : string, file : File, progressFn: (prog) => void = null, showSpinner = true) : Promise<string> {
  return CommonServices.uploadFileToUrl<string>(baseUrl + 'api/Fiera/UpdateLogoImage?communityIdentifier=' + communityIdentifier, file, { }, progressFn, showSpinner)
  }

  

  



    

    

    

      

    

    

    


  



  addGalleryImages(communityIdentifier : string, files : File[], progressFn: (prog) => void = null, showSpinner = true) : Promise<void> {
  return CommonServices.uploadFilesToUrl<void>(baseUrl + 'api/Fiera/AddGalleryImages?communityIdentifier=' + communityIdentifier, files, { }, progressFn, showSpinner)
  }

  

  



    

    

    

      

    

    

    


  



  addGalleryImage(communityIdentifier : string, file : File, progressFn: (prog) => void = null, showSpinner = true) : Promise<string> {
  return CommonServices.uploadFileToUrl<string>(baseUrl + 'api/Fiera/AddGalleryImage?communityIdentifier=' + communityIdentifier, file, { }, progressFn, showSpinner)
  }

  

  



    

    

    

      

    

    

    


  



  addSellingConditions(communityIdentifier : string, file : File, progressFn: (prog) => void = null, showSpinner = true) : Promise<void> {
  return CommonServices.uploadFileToUrl<void>(baseUrl + 'api/Fiera/AddSellingConditions?communityIdentifier=' + communityIdentifier, file, { }, progressFn, showSpinner)
  }
}
export let FieraClient = new _FieraClient();

class _ForumTagClient {

  

  



    

    

    


  



  getPublishedTag(communityIdentifier : string, showSpinner = true) : Promise<OM.SaveForumTagVM[]> {
  return CommonServices.defaultGet<OM.SaveForumTagVM[]>(baseUrl + 'api/ForumTag/GetPublishedTag', { communityIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  getEnabledTag(communityIdentifier : string, showSpinner = true) : Promise<OM.ForumTag[]> {
  return CommonServices.defaultGet<OM.ForumTag[]>(baseUrl + 'api/ForumTag/GetEnabledTag', { communityIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  getFollowedTagsByCommunity(communityIdentifier : string, showSpinner = true) : Promise<string[]> {
  return CommonServices.defaultGet<string[]>(baseUrl + 'api/ForumTag/GetFollowedTagsByCommunity', { communityIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  followTag(tagIdentifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/ForumTag/FollowTag', { tagIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  unfollowTag(tagIdentifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/ForumTag/UnfollowTag', { tagIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  getPublishedTagAndPostsNumber(communityIdentifier : string, showSpinner = true) : Promise<OM.TagPostVM[]> {
  return CommonServices.defaultGet<OM.TagPostVM[]>(baseUrl + 'api/ForumTag/GetPublishedTagAndPostsNumber', { communityIdentifier }, showSpinner)
  }
}
export let ForumTagClient = new _ForumTagClient();

class _FriendRequestClient {

  

  



  getRequestsReceived(showSpinner = true) : Promise<OM.FriendRequestRoomVm[]> {
  return CommonServices.defaultGet<OM.FriendRequestRoomVm[]>(baseUrl + 'api/FriendRequest/GetRequestsReceived', {  }, showSpinner)
  }

  

  



    

    

    


  



  checkRequestSent(toUser : string, showSpinner = true) : Promise<string> {
  return CommonServices.defaultGet<string>(baseUrl + 'api/FriendRequest/CheckRequestSent', { toUser }, showSpinner)
  }

  

  



    

    

    


  



  getBaseChatRoomVm(identifier : string, showSpinner = true) : Promise<OM.BaseChatRoomVm> {
  return CommonServices.defaultGet<OM.BaseChatRoomVm>(baseUrl + 'api/FriendRequest/GetBaseChatRoomVm', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  getFriendRequestVm(identifier : string, showSpinner = true) : Promise<OM.FriendRequestRoomVm> {
  return CommonServices.defaultGet<OM.FriendRequestRoomVm>(baseUrl + 'api/FriendRequest/GetFriendRequestVm', { identifier }, showSpinner)
  }

  

  



  getRequestsSent(showSpinner = true) : Promise<OM.FriendRequestRoomVm[]> {
  return CommonServices.defaultGet<OM.FriendRequestRoomVm[]>(baseUrl + 'api/FriendRequest/GetRequestsSent', {  }, showSpinner)
  }

  

  



    

    

    


  



  makeFriendRequest(vm : OM.MakeFriendRequestVm, showSpinner = true) : Promise<string> {
  return CommonServices.defaultPost<string>(baseUrl + 'api/FriendRequest/MakeFriendRequest', vm, { }, showSpinner)
  }

  

  



    

    

    


  



  acceptFriendRequest(requestIdentifier : string, showSpinner = true) : Promise<string> {
  return CommonServices.defaultGet<string>(baseUrl + 'api/FriendRequest/AcceptFriendRequest', { requestIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  deleteFriendRequest(friendRequestIdentifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/FriendRequest/DeleteFriendRequest', { friendRequestIdentifier }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  

    

    

    


  



  getChatMessages(chatIdentifier : string, skip : number, take : number, showSpinner = true) : Promise<OM.ChatRoomMessageVM[]> {
  return CommonServices.defaultGet<OM.ChatRoomMessageVM[]>(baseUrl + 'api/FriendRequest/GetChatMessages', { chatIdentifier, skip, take }, showSpinner)
  }

  

  



  uploadChatImage(showSpinner = true) : Promise<string> {
  return CommonServices.defaultPost<string>(baseUrl + 'api/FriendRequest/UploadChatImage', null, { }, showSpinner)
  }
}
export let FriendRequestClient = new _FriendRequestClient();

class _HomeClient {

  

  



    

    

    


  



  globalSearch(query : string, showSpinner = true) : Promise<OM.SearchResultVm[]> {
  return CommonServices.defaultGet<OM.SearchResultVm[]>(baseUrl + 'api/Home/GlobalSearch', { query }, showSpinner)
  }
}
export let HomeClient = new _HomeClient();

class _LocalizedClient {

  

  



  getAll(showSpinner = true) : Promise<OM.LocalizedEntityVM[]> {
  return CommonServices.defaultGet<OM.LocalizedEntityVM[]>(baseUrl + 'api/Localized/GetAll', {  }, showSpinner)
  }

  

  



  getAllBackoffice(showSpinner = true) : Promise<OM.LocalizedEntity[]> {
  return CommonServices.defaultGet<OM.LocalizedEntity[]>(baseUrl + 'api/Localized/GetAllBackoffice', {  }, showSpinner)
  }

  

  



    

    

    


  



  getById(identifier : string, showSpinner = true) : Promise<OM.LocalizedEntity> {
  return CommonServices.defaultGet<OM.LocalizedEntity>(baseUrl + 'api/Localized/GetById', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  save(value : OM.LocalizedEntity, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/Localized/Save', value, { }, showSpinner)
  }

  

  



    

    

    


  



  saveLocalized(value : OM.KeyValuePairOfStringAndString, showSpinner = true) : Promise<OM.LocalizedEntityVM> {
  return CommonServices.defaultPost<OM.LocalizedEntityVM>(baseUrl + 'api/Localized/SaveLocalized', value, { }, showSpinner)
  }

  

  



    

    

    


  



  editLocalizedValue(item : OM.LocalizedEntity, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/Localized/EditLocalizedValue', item, { }, showSpinner)
  }
}
export let LocalizedClient = new _LocalizedClient();

class _MagiaClient {

  

  



  fixAllTag(showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Magia/FixAllTag', {  }, showSpinner)
  }

  

  



  fixChatMessageDateNull(showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Magia/FixChatMessageDateNull', {  }, showSpinner)
  }

  

  



    

    

    


  



  eliminaFileVuoti(userIdentifier : string, showSpinner = true) : Promise<OM.ConversationRoomVm[]> {
  return CommonServices.defaultGet<OM.ConversationRoomVm[]>(baseUrl + 'api/Magia/EliminaFileVuoti', { userIdentifier }, showSpinner)
  }

  

  



  testFFMPEG(showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Magia/TestFFMPEG', {  }, showSpinner)
  }

  

  



    

    

    


  



  testSendMessage(userIdentifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Magia/TestSendMessage', { userIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  dividiMessaggiDelleChat(psw : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Magia/DividiMessaggiDelleChat', { psw }, showSpinner)
  }
}
export let MagiaClient = new _MagiaClient();

class _NexiClient {

  

  



    

    

    


  



  getPaymentModel(model : OM.PaymentRequestVm, showSpinner = true) : Promise<OM.NexiClientModel> {
  return CommonServices.defaultPost<OM.NexiClientModel>(baseUrl + 'api/Nexi/GetPaymentModel', model, { }, showSpinner)
  }

  

  



    

    

    


  



  pay(paymentRequest : OM.NexiPaymentRequest, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/Nexi/Pay', paymentRequest, { }, showSpinner)
  }
}
export let NexiClient = new _NexiClient();

class _NotificationClient {

  

  



    

    

    


  



  setReadOn(guid : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Notification/SetReadOn', { guid }, showSpinner)
  }

  

  



  setNotificationOpened(showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Notification/SetNotificationOpened', {  }, showSpinner)
  }

  

  



  getNotifications(showSpinner = true) : Promise<OM.Notification[]> {
  return CommonServices.defaultGet<OM.Notification[]>(baseUrl + 'api/Notification/GetNotifications', {  }, showSpinner)
  }

  

  



    

    

    


  



  getNewNotificationCount(userIdentifier : string, showSpinner = true) : Promise<number> {
  return CommonServices.defaultGet<number>(baseUrl + 'api/Notification/GetNewNotificationCount', { userIdentifier }, showSpinner)
  }
}
export let NotificationClient = new _NotificationClient();

class _OrderClient {

  

  



    

    

    


  



  payWithWireTransfer(cartIdentifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Order/PayWithWireTransfer', { cartIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  deleteOrderById(orderIdentifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Order/DeleteOrderById', { orderIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  getUserOrders(userIdentifier : string, showSpinner = true) : Promise<OM.OrderResumeVM[]> {
  return CommonServices.defaultGet<OM.OrderResumeVM[]>(baseUrl + 'api/Order/GetUserOrders', { userIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  getOrdersByCommunity(communityIdentifier : string, showSpinner = true) : Promise<OM.BackofficeOrderModelVM> {
  return CommonServices.defaultGet<OM.BackofficeOrderModelVM>(baseUrl + 'api/Order/GetOrdersByCommunity', { communityIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  getOrderDetail(orderIdentifier : string, showSpinner = true) : Promise<OM.OrderVM> {
  return CommonServices.defaultGet<OM.OrderVM>(baseUrl + 'api/Order/GetOrderDetail', { orderIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  changeStatus(model : OM.ChangeOrderStatusVM, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/Order/ChangeStatus', model, { }, showSpinner)
  }
}
export let OrderClient = new _OrderClient();

class _PostClient {

  

  



    

    

    


  

    

    

    


  



  like(postIdentifier : string, like : boolean, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Post/Like', { postIdentifier, like }, showSpinner)
  }

  

  



    

    

    


  



  getPostVmById(postIdentifier : string, showSpinner = true) : Promise<OM.PostVm> {
  return CommonServices.defaultGet<OM.PostVm>(baseUrl + 'api/Post/GetPostVmById', { postIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  getByParent(identifier : string, showSpinner = true) : Promise<OM.PostVm[]> {
  return CommonServices.defaultGet<OM.PostVm[]>(baseUrl + 'api/Post/GetByParent', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  getByIdAdmin(identifier : string, showSpinner = true) : Promise<OM.PostVm> {
  return CommonServices.defaultGet<OM.PostVm>(baseUrl + 'api/Post/GetByIdAdmin', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  deletePostAdmin(identifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Post/DeletePostAdmin', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  getForumPostByParent(vm : OM.ForumPostSearchVM, showSpinner = true) : Promise<OM.PostVm[]> {
  return CommonServices.defaultPost<OM.PostVm[]>(baseUrl + 'api/Post/GetForumPostByParent', vm, { }, showSpinner)
  }

  

  



    

    

    


  



  getByParentAllegati(parentSlug : string, showSpinner = true) : Promise<OM.PostVm[]> {
  return CommonServices.defaultGet<OM.PostVm[]>(baseUrl + 'api/Post/GetByParentAllegati', { parentSlug }, showSpinner)
  }

  

  



    

    

    


  



  deletePost(postIdentifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Post/DeletePost', { postIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  updatePost(vm : OM.UpdatePostVm, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/Post/UpdatePost', vm, { }, showSpinner)
  }

  

  



    

    

    


  



  createPost(vm : OM.CreatePostVm, showSpinner = true) : Promise<string> {
  return CommonServices.defaultPost<string>(baseUrl + 'api/Post/CreatePost', vm, { }, showSpinner)
  }

  

  



    

    

    


  



  createOrUpdatePost(vm : OM.CreatePostVm, showSpinner = true) : Promise<string> {
  return CommonServices.defaultPost<string>(baseUrl + 'api/Post/CreateOrUpdatePost', vm, { }, showSpinner)
  }

  

  



    

    

    


  



  createForumPost(vm : OM.CreateForumPostVm, showSpinner = true) : Promise<string> {
  return CommonServices.defaultPost<string>(baseUrl + 'api/Post/CreateForumPost', vm, { }, showSpinner)
  }

  

  



    

    

    

      

    

    

    


  



  updatePostImage(identifier : string, file : File, progressFn: (prog) => void = null, showSpinner = true) : Promise<void> {
  return CommonServices.uploadFileToUrl<void>(baseUrl + 'api/Post/UpdatePostImage?identifier=' + identifier, file, { }, progressFn, showSpinner)
  }

  

  



    

    

    


  



  deletePostImage(identifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Post/DeletePostImage', { identifier }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  



  getAllPostsByUserCommunities(skip : number, take : number, showSpinner = true) : Promise<OM.PostVm[]> {
  return CommonServices.defaultGet<OM.PostVm[]>(baseUrl + 'api/Post/GetAllPostsByUserCommunities', { skip, take }, showSpinner)
  }
}
export let PostClient = new _PostClient();

class _ReportClient {

  

  



    

    

    


  



  createReport(createReport : OM.CreateReport, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/Report/CreateReport', createReport, { }, showSpinner)
  }

  

  



    

    

    


  



  refuseReport(reportIdentifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Report/RefuseReport', { reportIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  approveReport(reportIdentifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Report/ApproveReport', { reportIdentifier }, showSpinner)
  }

  

  



  getAllReports(showSpinner = true) : Promise<OM.ReportList[]> {
  return CommonServices.defaultGet<OM.ReportList[]>(baseUrl + 'api/Report/GetAllReports', {  }, showSpinner)
  }
}
export let ReportClient = new _ReportClient();

class _ShopClient {

  

  



    

    

    


  



  getCategories(communityIdentifier : string, showSpinner = true) : Promise<string[]> {
  return CommonServices.defaultGet<string[]>(baseUrl + 'api/Shop/GetCategories', { communityIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  getItemsByCommunity(communityIdentifier : string, showSpinner = true) : Promise<OM.CommunityShopItemsVM> {
  return CommonServices.defaultGet<OM.CommunityShopItemsVM>(baseUrl + 'api/Shop/GetItemsByCommunity', { communityIdentifier }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  



  getShopItemDetail(communityIdentifier : string, shopItemIdentifier : string, showSpinner = true) : Promise<OM.CategoryShopItemVM> {
  return CommonServices.defaultGet<OM.CategoryShopItemVM>(baseUrl + 'api/Shop/GetShopItemDetail', { communityIdentifier, shopItemIdentifier }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  



  getShopItemDetailBySlug(communityIdentifier : string, slug : string, showSpinner = true) : Promise<OM.CategoryShopItemVM> {
  return CommonServices.defaultGet<OM.CategoryShopItemVM>(baseUrl + 'api/Shop/GetShopItemDetailBySlug', { communityIdentifier, slug }, showSpinner)
  }

  

  



    

    

    


  



  editItem(model : OM.EditItemVm, showSpinner = true) : Promise<OM.ShopItem> {
  return CommonServices.defaultPost<OM.ShopItem>(baseUrl + 'api/Shop/EditItem', model, { }, showSpinner)
  }

  

  



  reSaveShopAllWithSlug(showSpinner = true) : Promise<string> {
  return CommonServices.defaultGet<string>(baseUrl + 'api/Shop/ReSaveShopAllWithSlug', {  }, showSpinner)
  }

  

  



    

    

    


  



  deleteItem(shopItemIdentifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Shop/DeleteItem', { shopItemIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  editItemVariation(model : OM.CreateItemVariationVm, showSpinner = true) : Promise<OM.ShopItem> {
  return CommonServices.defaultPost<OM.ShopItem>(baseUrl + 'api/Shop/EditItemVariation', model, { }, showSpinner)
  }

  

  



    

    

    


  



  createDateItemVariation(model : OM.CreateDateItemVariationVm, showSpinner = true) : Promise<OM.ShopItem> {
  return CommonServices.defaultPost<OM.ShopItem>(baseUrl + 'api/Shop/CreateDateItemVariation', model, { }, showSpinner)
  }

  

  



    

    

    


  



  createPeriodItemVariation(model : OM.CreatePeriodItemVariationVm, showSpinner = true) : Promise<OM.ShopItem> {
  return CommonServices.defaultPost<OM.ShopItem>(baseUrl + 'api/Shop/CreatePeriodItemVariation', model, { }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  



  deleteItemVariation(shopItemIdentifier : string, index : number, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Shop/DeleteItemVariation', { shopItemIdentifier, index }, showSpinner)
  }

  

  



    

    

    

      

    

    

    


  



  addToGallery(identifier : string, file : File, progressFn: (prog) => void = null, showSpinner = true) : Promise<string> {
  return CommonServices.uploadFileToUrl<string>(baseUrl + 'api/Shop/AddToGallery?identifier=' + identifier, file, { }, progressFn, showSpinner)
  }

  

  



    

    

    


  



  removeFromGallery(vm : OM.NameIdentifier, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/Shop/RemoveFromGallery', vm, { }, showSpinner)
  }

  

  



    

    

    


  



  getShopItemsByCommunity(communityIdentifier : string, showSpinner = true) : Promise<OM.ShopAppVM> {
  return CommonServices.defaultGet<OM.ShopAppVM>(baseUrl + 'api/Shop/GetShopItemsByCommunity', { communityIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  getShopItemsByEvent(eventIdentifier : string, showSpinner = true) : Promise<OM.ShopAppVM> {
  return CommonServices.defaultGet<OM.ShopAppVM>(baseUrl + 'api/Shop/GetShopItemsByEvent', { eventIdentifier }, showSpinner)
  }
}
export let ShopClient = new _ShopClient();

class _TestClient {

  

  



  checkLogin(showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Test/CheckLogin', {  }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  



  testPush(psw : string, email : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Test/TestPush', { psw, email }, showSpinner)
  }
}
export let TestClient = new _TestClient();

class _UserClient {

  

  



  getMe(showSpinner = true) : Promise<OM.AppUserVm> {
  return CommonServices.defaultGet<OM.AppUserVm>(baseUrl + 'api/User/GetMe', {  }, showSpinner)
  }

  

  



  acceptAllNewMandatoryDocumentsAfterLogin(showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/User/AcceptAllNewMandatoryDocumentsAfterLogin', {  }, showSpinner)
  }

  

  



  deleteAccount(showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/User/DeleteAccount', {  }, showSpinner)
  }

  

  



    

    

    


  



  blockUser(userIdentifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/User/BlockUser', { userIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  unBlockUser(vm : OM.SetListVmOfGuid, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/User/UnBlockUser', vm, { }, showSpinner)
  }

  

  



  getUsersBlocked(showSpinner = true) : Promise<OM.NameIdentifier[]> {
  return CommonServices.defaultGet<OM.NameIdentifier[]>(baseUrl + 'api/User/GetUsersBlocked', {  }, showSpinner)
  }

  

  



  checkIfProfileCompleted(showSpinner = true) : Promise<boolean> {
  return CommonServices.defaultGet<boolean>(baseUrl + 'api/User/CheckIfProfileCompleted', {  }, showSpinner)
  }

  

  



    

    

    


  



  checkPrivacyAndTerms(userIdentifier : string, showSpinner = true) : Promise<boolean> {
  return CommonServices.defaultGet<boolean>(baseUrl + 'api/User/CheckPrivacyAndTerms', { userIdentifier }, showSpinner)
  }

  

  



  hasOldPassword(showSpinner = true) : Promise<boolean> {
  return CommonServices.defaultGet<boolean>(baseUrl + 'api/User/HasOldPassword', {  }, showSpinner)
  }

  

  



    

    

    


  



  acceptPrivacyAndTerms(userIdentifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/User/AcceptPrivacyAndTerms', { userIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  getMyEventsByMonth(date : string, showSpinner = true) : Promise<OM.EventCalendarVM[]> {
  return CommonServices.defaultGet<OM.EventCalendarVM[]>(baseUrl + 'api/User/GetMyEventsByMonth', { date }, showSpinner)
  }

  

  



    

    

    


  



  getMyEventByDay(date : string, showSpinner = true) : Promise<OM.CommunityListVm[]> {
  return CommonServices.defaultGet<OM.CommunityListVm[]>(baseUrl + 'api/User/GetMyEventByDay', { date }, showSpinner)
  }

  

  



  getMeBackend(showSpinner = true) : Promise<OM.BackendUserVm> {
  return CommonServices.defaultGet<OM.BackendUserVm>(baseUrl + 'api/User/GetMeBackend', {  }, showSpinner)
  }

  

  



    

    

    


  



  searchUser(query : string, showSpinner = true) : Promise<OM.SearchUserVM[]> {
  return CommonServices.defaultGet<OM.SearchUserVM[]>(baseUrl + 'api/User/SearchUser', { query }, showSpinner)
  }

  

  



    

    

    


  



  getContactsAndCommunityMembers(communityIdentifier : string, showSpinner = true) : Promise<OM.NameIdentifier[]> {
  return CommonServices.defaultGet<OM.NameIdentifier[]>(baseUrl + 'api/User/GetContactsAndCommunityMembers', { communityIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  updateAppUser(user : OM.AppUserVm, showSpinner = true) : Promise<string> {
  return CommonServices.defaultPost<string>(baseUrl + 'api/User/UpdateAppUser', user, { }, showSpinner)
  }

  

  



    

    

    


  



  updateUserDescription(vm : OM.NameIdentifier, showSpinner = true) : Promise<string> {
  return CommonServices.defaultPost<string>(baseUrl + 'api/User/UpdateUserDescription', vm, { }, showSpinner)
  }

  

  



    

    

    


  



  setFcmId(fcm : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/User/SetFcmId', { fcm }, showSpinner)
  }

  

  



    

    

    


  



  updateUserEmail(vm : OM.NameIdentifier, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/User/UpdateUserEmail', vm, { }, showSpinner)
  }

  

  



    

    

    


  



  updateUserNumber(vm : OM.NameIdentifier, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/User/UpdateUserNumber', vm, { }, showSpinner)
  }

  

  



    

    

    


  



  updateUserName(vm : OM.NameIdentifier, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/User/UpdateUserName', vm, { }, showSpinner)
  }

  

  



    

    

    


  



  updateSurname(vm : OM.NameIdentifier, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/User/UpdateSurname', vm, { }, showSpinner)
  }

  

  



    

    

    


  



  updateGender(vm : OM.NameIdentifier, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/User/UpdateGender', vm, { }, showSpinner)
  }

  

  



    

    

    


  



  updateBirthDate(vm : OM.DateIdentifier, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/User/UpdateBirthDate', vm, { }, showSpinner)
  }

  

  



    

    

    


  



  getProfile(userIdentifier : string, showSpinner = true) : Promise<OM.UserProfileVm> {
  return CommonServices.defaultGet<OM.UserProfileVm>(baseUrl + 'api/User/GetProfile', { userIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  getSelfProfile(userIdentifier : string, showSpinner = true) : Promise<OM.UserSelfProfileVm> {
  return CommonServices.defaultGet<OM.UserSelfProfileVm>(baseUrl + 'api/User/GetSelfProfile', { userIdentifier }, showSpinner)
  }

  

  



    

    

    

      

    

    

    


  



  saveProfileImage(identifier : string, file : File, progressFn: (prog) => void = null, showSpinner = true) : Promise<void> {
  return CommonServices.uploadFileToUrl<void>(baseUrl + 'api/User/SaveProfileImage?identifier=' + identifier, file, { }, progressFn, showSpinner)
  }

  

  



    

    

    


  



  search(search : string, showSpinner = true) : Promise<OM.NameIdentifier[]> {
  return CommonServices.defaultGet<OM.NameIdentifier[]>(baseUrl + 'api/User/Search', { search }, showSpinner)
  }

  

  



  getAllAsNameIdentifier(showSpinner = true) : Promise<OM.NameIdentifier[]> {
  return CommonServices.defaultGet<OM.NameIdentifier[]>(baseUrl + 'api/User/GetAllAsNameIdentifier', {  }, showSpinner)
  }

  

  



    

    

    


  



  confirmAppUser(identifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/User/ConfirmAppUser', { identifier }, showSpinner)
  }

  

  



  getAppUsers(showSpinner = true) : Promise<OM.UserListVm[]> {
  return CommonServices.defaultGet<OM.UserListVm[]>(baseUrl + 'api/User/GetAppUsers', {  }, showSpinner)
  }

  

  



  getBackendUsers(showSpinner = true) : Promise<OM.UserListVm[]> {
  return CommonServices.defaultGet<OM.UserListVm[]>(baseUrl + 'api/User/GetBackendUsers', {  }, showSpinner)
  }

  

  



    

    

    


  



  getSingleUserListVm(identifier : string, showSpinner = true) : Promise<OM.UserListVm> {
  return CommonServices.defaultGet<OM.UserListVm>(baseUrl + 'api/User/GetSingleUserListVm', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  deleteById(identifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/User/DeleteById', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  getBackendUserDetail(identifier : string, showSpinner = true) : Promise<OM.SaveBackendUserVm> {
  return CommonServices.defaultGet<OM.SaveBackendUserVm>(baseUrl + 'api/User/GetBackendUserDetail', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  saveBackendUserDetail(vm : OM.SaveBackendUserVm, showSpinner = true) : Promise<string> {
  return CommonServices.defaultPost<string>(baseUrl + 'api/User/SaveBackendUserDetail', vm, { }, showSpinner)
  }

  

  



    

    

    


  



  completeProfile(model : OM.CompleteProfileVM, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/User/CompleteProfile', model, { }, showSpinner)
  }

  

  



  getProfileVM(showSpinner = true) : Promise<OM.CompleteProfileVM> {
  return CommonServices.defaultGet<OM.CompleteProfileVM>(baseUrl + 'api/User/GetProfileVM', {  }, showSpinner)
  }
}
export let UserClient = new _UserClient();

class _WeatherForecastClient {

  

  



  get(showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'WeatherForecast', {  }, showSpinner)
  }
}
export let WeatherForecastClient = new _WeatherForecastClient();

class _AfterLoginMandatoryDocumentClient {

  

  



    

    

    


  



  create(mandatoryDocumentCreateVM : OM.MandatoryDocumentCreateVM, showSpinner = true) : Promise<string> {
  return CommonServices.defaultPost<string>(baseUrl + 'api/AfterLoginMandatoryDocument/Create', mandatoryDocumentCreateVM, { }, showSpinner)
  }

  

  



  getMandatoryMustSign(showSpinner = true) : Promise<OM.MandatoryDocumentAppVM[]> {
  return CommonServices.defaultGet<OM.MandatoryDocumentAppVM[]>(baseUrl + 'api/AfterLoginMandatoryDocument/GetMandatoryMustSign', {  }, showSpinner)
  }

  

  



  getRegistrationMustSign(showSpinner = true) : Promise<OM.MandatoryDocumentAppVM[]> {
  return CommonServices.defaultGet<OM.MandatoryDocumentAppVM[]>(baseUrl + 'api/AfterLoginMandatoryDocument/GetRegistrationMustSign', {  }, showSpinner)
  }
}
export let AfterLoginMandatoryDocumentClient = new _AfterLoginMandatoryDocumentClient();

class _BaseMandatoryDocumentClient {

  

  



    

    

    


  



  edit(mandatoryDocumentEditVM : OM.MandatoryDocumentEditVM, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/BaseMandatoryDocument/Edit', mandatoryDocumentEditVM, { }, showSpinner)
  }

  

  



  getAllMandatoryDocumentTypes(showSpinner = true) : Promise<string[]> {
  return CommonServices.defaultGet<string[]>(baseUrl + 'api/BaseMandatoryDocument/GetAllMandatoryDocumentTypes', {  }, showSpinner)
  }

  

  



  getAllMandatoryDocuments(showSpinner = true) : Promise<OM.MandatoryDocumentListVM[]> {
  return CommonServices.defaultGet<OM.MandatoryDocumentListVM[]>(baseUrl + 'api/BaseMandatoryDocument/GetAllMandatoryDocuments', {  }, showSpinner)
  }

  

  



    

    

    


  



  disable(documentIdentifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/BaseMandatoryDocument/Disable', { documentIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  enable(documentIdentifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/BaseMandatoryDocument/Enable', { documentIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  publish(documentIdentifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/BaseMandatoryDocument/Publish', { documentIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  hide(documentIdentifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/BaseMandatoryDocument/Hide', { documentIdentifier }, showSpinner)
  }
}
export let BaseMandatoryDocumentClient = new _BaseMandatoryDocumentClient();

class _MandatoryDocumentCategoryClient {

  

  



    

    

    


  



  create(createMandatoryDocumentCategory : OM.MandatoryDocumentCategoryCreateVM, showSpinner = true) : Promise<string> {
  return CommonServices.defaultPost<string>(baseUrl + 'api/MandatoryDocumentCategory/Create', createMandatoryDocumentCategory, { }, showSpinner)
  }

  

  



    

    

    


  



  edit(editMandatoryDocumentCategory : OM.MandatoryDocumentCategoryEditVM, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/MandatoryDocumentCategory/Edit', editMandatoryDocumentCategory, { }, showSpinner)
  }

  

  



  getAll(showSpinner = true) : Promise<OM.MandatoryDocumentCategoryListVM[]> {
  return CommonServices.defaultGet<OM.MandatoryDocumentCategoryListVM[]>(baseUrl + 'api/MandatoryDocumentCategory/GetAll', {  }, showSpinner)
  }

  

  



  getAllAsTextIdentifier(showSpinner = true) : Promise<OM.TextIdentifier[]> {
  return CommonServices.defaultGet<OM.TextIdentifier[]>(baseUrl + 'api/MandatoryDocumentCategory/GetAllAsTextIdentifier', {  }, showSpinner)
  }
}
export let MandatoryDocumentCategoryClient = new _MandatoryDocumentCategoryClient();

interface FileParameter {
    data: any;
    fileName: string;
}

interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}